@if (showInviteButton && !isLti()) {
	<button
		type="button"
		class="overview-invite secondary-btn"
		(click)="openInviteModal()"
		[attr.aria-label]="'activity-report_invite-learners-aria' | translate">
		<span class="overview-invite-label">
			{{ 'activity-report_invite-learners' | translate }}
		</span>
		<i class="overview-invite-icon ficon-add-user" aria-hidden="true"></i>
	</button>
}
<task-list-navigator
	[currentTaskIndex]="currentPageIndex"
	[totalTasks]="TOTAL_PAGES"
	(navigateBack)="onNavigateBack()"
	(navigateForward)="onNavigateForward()"
	(openNavigator)="onOpenNavigator()">
</task-list-navigator>
